import { render, staticRenderFns } from "./InvalidImageDialog.vue?vue&type=template&id=21b0c11f"
import script from "./InvalidImageDialog.vue?vue&type=script&lang=js"
export * from "./InvalidImageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports